import React from "react";

const goalsData = [
  {
    id: 1,
    goal: "To Increase Access to Clean Energy by providing affordable LPG/cooking gas to about 5,000 households in low-income communities, 1,000 households per year within the first five years of operation, ensuring reliable access to clean cooking gas and reducing reliance on biomass fuels",
    image: "/images/goal-1.avif",
    invert: false,
  },
  {
    id: 2,
    goal: "To help low-income households save up to 30% on energy costs by accepting  recyclables as an alternative payment method, reducing financial barriers to clean energy access.",
    image: "/images/save.avif",
    invert: true,
  },
  {
    id: 3,
    goal: "To promote Recycling and Reduce Plastic Waste through our waste-to-fuel program, to mitigate environmental pollution and transform waste into valuable resources, thereby contributing to a cleaner environment.",
    image: "/images/rehhd.avif",
    invert: false,
  },
  {
    id: 4,
    goal: "Establish collaborations with recycling companies, relevant governmental organizations, and non-governmental organizations to enhance value delivery such as clean energy acquisition, distribution, waste management, waste collection, and upscaling.",
    image: "/images/recyle.avif",
    invert: true,
  },
  {
    id: 5,
    goal: "In all, contribute to reducing CO2 emissions by at least 20% in target communities within the first five years, and help achieve the national and global climate goals, while promoting cleaner energy alternatives",
    image: "/images/co2.avif",
    invert: false,
  },
];

const Vision = React.forwardRef((props, ref) => {
  return (
    <div className="" ref={ref}>
      <div className="w-[90%] mx-auto py-4 flex flex-col gap-4">
        <h1 className="text-2xl md:text-4xl text-[#f46524]">
          Waste to Wealth: A Circular Economy Solution{" "}
        </h1>
        <div className="grid md:grid-cols-2 gap-4">
          {/* <img src="/images/bbg.avif" alt="" className="" /> */}
          <div
            className="w-full md:h-full h-[300px]"
            style={{
              backgroundImage: `url("/images/bbg.avif")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          ></div>
          <div className="flex flex-col gap-4">
            <h2 className=" text-xl">
              <span className="text-[#38761d] font-bold">Guerate Energy</span>{" "}
              was conceived out of a pressing need to address energy poverty and
              affordability, particularly for cooking fuel in Nigeria.
            </h2>
            <h2 className=" text-xl">
              <span className="text-[#38761d] font-bold">Guerate Energy</span>{" "}
              solution aims to leverage the volume of uncollected plastic waste
              in communities as a resource to create a sustainable solution to
              energy poverty and affordability.{" "}
              <span className="text-[#38761d] font-bold">Guerate Energy</span>{" "}
              stands at the forefront of social enterprise innovation, tackling
              energy poverty, environmental pollution, and economic challenges
              in low-income communities.
            </h2>
            <h2 className=" text-xl">
              By redefining waste as a resource,{" "}
              <span className="text-[#38761d] font-bold">Guerate Energy</span>{" "}
              hopes to empower communities, promote sustainability, and
              contribute to a healthier and cleaner Africa.
            </h2>
          </div>
        </div>
      </div>
      <div className="bg-red-600 w-full py-8">
        <div className="w-[90%] mx-auto flex flex-col gap-7">
          <h1 className="text-4xl md:text-6xl text-[#fff]">
            Our Key Objectives and Goals
          </h1>
          {goalsData.map((goal) => {
            return (
              <div
                key={goal.id}
                className={`md:grid md:grid-cols-2 gap-4 ${
                  goal.invert ? "grid-areas-reversed" : "grid-areas-normal"
                }`}
                style={{
                  gridTemplateAreas: goal.invert
                    ? "'image text'"
                    : "'text image'",
                }}
              >
                <div
                  className="flex gap-3 py-4"
                  style={{
                    gridArea: "text",
                  }}
                >
                  <div className="rounded-full px-4 py-2 w-fit h-fit bg-white">
                    {goal.id}
                  </div>
                  <p className=" text-[#fff]">{goal.goal}</p>
                </div>

                <div className="md:flex hidden items-center h-full shadow-2xl">
                  <div className="w-[20px] bg-[#38761d] h-full"></div>
                  <div className="w-[10px] bg-[#f46524] h-full"></div>
                  <div
                    className="lg:h-[200px] h-full w-full"
                    style={{
                      gridArea: "image",
                      backgroundImage: `url('${goal.image}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                    }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
});

export default Vision;
